import { auth } from './reducer';
export default auth;